"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectHtgHsToHtgHx = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Connector = require("./Connector");
var _constants = require("../../../utils/constants");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _selectors = require("../../../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ConnectHtgHsToHtgHxItem = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    index
  } = _ref;
  const HtgHsFromHtgSys = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type: _constants.TypesByDep.HtgHsFromHtgSys
  });
  const HtgHsGeneral = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type: _constants.TypesByDep.HtgHsGeneral
  });
  const HtgHsFromGeneral = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type: _constants.TypesByDep.HtgHsFromGeneral
  });
  const getLastHtgHsGroup = () => {
    if (HtgHsFromGeneral.length) return HtgHsFromGeneral;
    if (HtgHsGeneral.length) return HtgHsGeneral;
    if (HtgHsFromHtgSys.length) return HtgHsFromHtgSys;
    return [];
  };
  const lastHtgHsGroup = getLastHtgHsGroup();
  const HtgHx = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type: _constants.TypesByDep.HtgHx
  });
  const connectWithPrevious = Boolean(index && [HtgHx[index], lastHtgHsGroup[index]].some(id => !id));
  const getConnectTo = () => {
    if (!connectWithPrevious) return _constants.ConnectTo.null;
    if (HtgHx[index] && !lastHtgHsGroup[index]) return _constants.ConnectTo.left;
    return _constants.ConnectTo.right;
  };
  const isSecond = index === 1;
  return /*#__PURE__*/_react.default.createElement(_Connector.Connector, {
    position: [-index * _constants.spaseBetweenModelsByCol, 0, 0],
    pipes: [{
      highlightsType: _constants.pipesTypes.heatingReturn,
      display: true
    }, {
      highlightsType: _constants.pipesTypes.heatingFlow,
      display: true
    }],
    connectTo: getConnectTo(),
    connectWithPrevious: connectWithPrevious,
    isSecondConnect: isSecond,
    index: index
  });
});
ConnectHtgHsToHtgHxItem.propTypes = {
  index: _propTypes.default.number
};
const ConnectHtgHsToHtgHx = exports.ConnectHtgHsToHtgHx = /*#__PURE__*/(0, _react.memo)(() => {
  const type = _constants.TypesConnect.ConnectHtgHsToHtgHx;
  const HtgHx = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type: _constants.TypesByDep.HtgHx
  });
  const modelShow = (0, _reactRedux.useSelector)(_selectors.selectStructureShowModel)[type];
  const modelPosition = (0, _reactRedux.useSelector)(_selectors.selectStructurePositions)[type];
  if (!modelShow) return null;
  return /*#__PURE__*/_react.default.createElement("group", {
    dispose: null,
    position: modelPosition
  }, HtgHx.length ? HtgHx.map((item, index) => /*#__PURE__*/_react.default.createElement(ConnectHtgHsToHtgHxItem, {
    key: (item === null || item === void 0 ? void 0 : item.id) || index,
    index: index
  })) : /*#__PURE__*/_react.default.createElement(_Connector.Connector, {
    position: [0, 0, 0],
    pipes: [{
      highlightsType: _constants.pipesTypes.heatingReturn,
      display: true
    }, {
      highlightsType: _constants.pipesTypes.heatingFlow,
      display: true
    }],
    connectTo: _constants.ConnectTo.null,
    index: 0
  }));
});